import { render, staticRenderFns } from "./ItemImageUpdate.vue?vue&type=template&id=7c4fa49a&scoped=true&"
import script from "./ItemImageUpdate.vue?vue&type=script&lang=js&"
export * from "./ItemImageUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ItemImageUpdate.vue?vue&type=style&index=0&id=7c4fa49a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4fa49a",
  null
  
)

export default component.exports